var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "datepicker-container" }, [
    _c(
      "div",
      { staticClass: "datepicker-container__wrap" },
      [
        _vm.type > 1 && _vm.type <= 30
          ? _c(
              "a-range-picker",
              {
                ref: "datepicker",
                class: { isError: _vm.isError },
                attrs: {
                  format: _vm.format,
                  "disabled-date": _vm.disabledDate,
                  value: _vm.value,
                  "show-time": "",
                  mode: _vm.mode2,
                  placeholder: ["Start Date", "End Date"],
                  disabled: _vm.disabled,
                },
                on: { change: _vm.handleDateChange },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "dateRender",
                      fn: function (current, today) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "ant-calendar-date",
                              style: _vm.getCurrentStyle(current, today),
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(current.date()) +
                                  "\n        "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1793832782
                ),
              },
              [
                _vm._v(" "),
                _c("a-icon", {
                  attrs: { slot: "suffixIcon", type: "calendar" },
                  slot: "suffixIcon",
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.type === 1
          ? _c("a-date-picker", {
              ref: "datepicker",
              class: { "is-error": _vm.isError },
              attrs: {
                format: _vm.format,
                "disabled-date": _vm.disabledDate,
                value: _vm.value,
                placeholder: "Select Date",
                disabled: _vm.disabled,
              },
              on: { change: _vm.handleDateChange },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.type > 30
          ? _c("a-range-picker", {
              attrs: {
                placeholder: ["Start Month", "End Month"],
                format: "YYYY-MM",
                value: _vm.value,
                mode: _vm.mode2,
                disabled: _vm.disabled,
              },
              on: {
                panelChange: _vm.handlePanelChange,
                change: _vm.handleDateChange,
              },
            })
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _vm.isError
      ? _c("div", { staticClass: "datepicker-container__error-message" }, [
          _vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  "),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }